module.exports = __webpack_public_path__ + "img/3.a9a3e521.png";